/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './diaglab-history.reducer';

export const DiaglabHistoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const diaglabHistoryEntity = useAppSelector(state => state.diaglabHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="diaglabHistoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.diaglabHistory.detail.title">DiaglabHistory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.diaglabHistory.id">Id</Translate>
            </span>
          </dt>
          <dd>{diaglabHistoryEntity.id}</dd>
          <dt>
            <span id="billNumber">
              <Translate contentKey="tinyMedicRestApp.diaglabHistory.billNumber">Bill Number</Translate>
            </span>
          </dt>
          <dd>{diaglabHistoryEntity.billNumber}</dd>
          <dt>
            <span id="noOfItems">
              <Translate contentKey="tinyMedicRestApp.diaglabHistory.noOfItems">No Of Items</Translate>
            </span>
          </dt>
          <dd>{diaglabHistoryEntity.noOfItems}</dd>
          <dt>
            <span id="excluded">
              <Translate contentKey="tinyMedicRestApp.diaglabHistory.excluded">Excluded</Translate>
            </span>
          </dt>
          <dd>{diaglabHistoryEntity.excluded}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.diaglabHistory.active">Active</Translate>
            </span>
          </dt>
          <dd>{diaglabHistoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.diaglabHistory.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{diaglabHistoryEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.diaglabHistory.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{diaglabHistoryEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.diaglabHistory.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{diaglabHistoryEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.diaglabHistory.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{diaglabHistoryEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabHistory.prescription">Prescription</Translate>
          </dt>
          <dd>{diaglabHistoryEntity.prescription ? diaglabHistoryEntity.prescription.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabHistory.diagLab">Diag Lab</Translate>
          </dt>
          <dd>{diaglabHistoryEntity.diagLab ? diaglabHistoryEntity.diagLab.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/diaglab-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/diaglab-history/${diaglabHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DiaglabHistoryDetail;
